import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { DocumentService } from '../../services/coreService/document.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription, Observable } from 'rxjs';
import { CoreVm, AddCoreVm, FileModelVM, AddContactVm, AddCompanyVm } from 'src/app/viewModels/core/core-vm';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { map, startWith } from 'rxjs/operators';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ModuleName } from '../../services/coreService/contact.enum';
import { ActivatedRoute } from '@angular/router';
import { OpenHTMLFormComponent } from 'src/app/middleware/common/openHtmlForm/openHtmlForm.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-core-parent',
  templateUrl: './core-parent.component.html',
  styleUrls: ['./core-parent.component.scss'],
})

export class CoreParentComponent implements OnInit {
  addressFormGroup: any = [];
  cityValue: any;
  stateValue: any;
  zipValue: any;
  countryValue: any;
  addressValueField: any = Object;
  cityValueField: any = Object;
  stateValueField: any = Object;
  zipValueField: any = Object;
  arryaControlNameIdpare: any = [];
  arrayControlNameSubfolderID: any = [];
  emptyArrya: any = [];
  isTypeChanged: boolean = false;
  checkboxnames: any = [];
  tagvalues: string;
  matTabIndex: number = 0;
  gModel = {
    userID: '',
    databaseID: 0,
    folderID: 0,
  };
  contactCoreListing: any[];
  folderList: any;
  folderID: any;
  myOfficeID: any;
  OfficeIDList: any = [];
  constructor(private formBuilder: FormBuilder, private statusConst: StatusConstant, private loaderService: LoaderService,
    private coreService: CoreService, private documentService: DocumentService, private toastr: ToastrService,
    private settingService: SettingService, private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private constant: Constants, private _dataSharingService: DataSharingService, private coreVm: CoreVm,
    private addCoreVm: AddCoreVm, private addContactVm: AddContactVm, private addCompanyVm: AddCompanyVm,
    private fileModelVM: FileModelVM, private settingsService: SettingService, private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,private dialog: MatDialog) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this.allTags.slice()));
  }

  ImagePathURL: string = '';
  imageSrc: string;
  FileName: any;
  FileExtention: any;
  Base64String: any;
  chkStatusArry: any;
  coreFieldList: any;
  checkBoxList: any = [];
  currentUser: any;
  transactionUserName: any;
  transactionUserRole: any;
  openDocumentDetail: boolean = false;
  showUserDetail: boolean = false;
  showContactList: boolean = false;
  showCreateTouches: boolean = false;
  showContactdetail: boolean = false;
  showShareFile: boolean = false;
  documentViewer: boolean = false;
  htmlData: boolean = false;
  showCreateTask: boolean = false;
  showLinkPI: boolean = false;
  showTaskDetail: boolean = false;
  getFieldsListResponseHolder: any;
  fieldsList: any[] = [];
  fieldListFolderWise: any[] = [];
  dropdownlist: any;
  multipleDropdownList: any;
  getFieldModel = {
    userID: '',
    databaseID: 0,
    folderID: 0,
    officeID: 0
  };
  folderText = 'Task';
  dynamicArray: any;
  dynamicArrayEdit: any;
  dynamicArrayPhone: any;
  dynamicArrayAddress: any;
  dynamicArrayWebsite: any;

  dynamicArrayTemp: any;
  dynamicArrayEditTemp: any;
  dynamicArrayPhoneTemp: any;
  dynamicArrayAddressTemp: any;
  dynamicArrayWebsiteTemp: any;

  checkBoxFieldArray: Array<any> = [];
  checkBoxFieldAttribute: any = {
    Select: false,
  };

  inputTypeFieldArray: Array<any> = [];
  inputTypeFieldAttribute: any = {
    fieldText: '',
    placeholder: '',
  };

  dropdownFieldArray: Array<any> = [];
  dropdownFieldAttribute: any = {
    dropdownText: '',
  };

  showTextBoxField: boolean = false;
  showDropdownBoxField: boolean = false;
  showCheckboxField: boolean = false;
  clickEventsubscription: Subscription;
  coreUserList: any;
  responseHolder: any;
  transactionID: any;
  databaseId: string;
  organizationId: string;
  myFormGroup: FormGroup;
  TypeList: any = [];
  step = 0;
  TypeListForDropDown: any = [];
  TypeIdDrp: any;
  CityModel = {
    Name: '',
    databaseID: 0,
    userID: ''
  };
  ZipModel = {
    ZipCodeValue: '',
    databaseID: 0,
    userID: ''
  };
  zipOption: any[];
  stateList: any[];
  cityOption: string[] = [];
  getTagListResponseHolder: any;
  getTagListModel = {
    tagName: "",
    fieldID: 0,
    databaseID: 0,
    organizationID: 0,
    PageSize: 0
  };
  showAdditionalField: boolean = false;
  expandAdditionalField: boolean = false;
  typeId: number = 0;

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;

  tags: string[];
  allTags: string[] = [];

  moduleName: string;
  contactVm = {
    DatabaseID: 0,
    OrganizationID: 0,
    UserID: '',
    PageIndex: 0,
    PageSize: 0,
    FolderId: 0,
    transactionID: 0,
    subFolderID: 0,
    searchKey: '',
    contactID: 0,
    officeID: 0,
    OfficeIDList: []
  }
  companyVm = {
    DatabaseID: 0,
    OrganizationID: 0,
    UserID: '',
    PageIndex: 0,
    PageSize: 0,
    FolderId: 0,
    transactionID: 0,
    subFolderID: 0,
    searchKey: '',
    companyID: 0,
  }
  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  mainModuleName: string = "";
  CCCList: any = [] = [];
  PreviousButton: boolean = false;
  NextButton: boolean = false;
  showPaycheck: boolean = false;
  Module: string = "";

  ngOnInit(): void {
    this.EmaildArray = [];
    this.dynamicArray = [];
    this.dynamicArrayPhone = [];
    this.dynamicArrayAddress = [];
    this.dynamicArrayWebsite = [];
    this.dynamicArrayAddressTemp = [];
    this.mainModuleName = ModuleName.Contact;
    this._dataSharingService.getSelectedHTMLDataForContact().subscribe((result) => {    
      if(result!=null && result != ""){               
        this.htmlData = true;        
      }     
    });
    // this.clickEventsubscription = this._dataSharingService.getSelectedContactUser().subscribe((result) => {
    //     if (result !== '') {        
    //       var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    //       var Module=[];
    //       Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
    //       if(Module.length>0){    
    //        this.folderID = Module[0].folderID;
    //       }
    //       let group = {};
    //       this.myFormGroup = new FormGroup(group);        
    //       this.transactionID = result.Id;
    //       this.moduleName = result.moduleName;
    //       sessionStorage.setItem('transactionID', result.Id);   
    //       sessionStorage.setItem('moduleName', result.moduleName);

    //       // if(sessionStorage.getItem('moduleName')  == ModuleName.Contact){           
    //       //   this.getContactUserDetailsforSubFolderId(); 
    //       // }          
    //       sessionStorage.setItem('HeaderModuleName', sessionStorage.getItem('moduleName'));
    //     }
    //   });

    this.mainModuleName = ModuleName.Contact;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
    if (Module.length > 0) {
      this.Module = Module[0].orgModuleName;
      this.folderID = Module[0].folderID;
    }

    this.route.queryParams.subscribe(params => {
      if (params != null) {
        this.transactionID = (params['tID']);
        this.TypeIdDrp = (params['type']);
        if (this.transactionID != undefined) {

          this.transactionID = atob(params['tID']);
          this.TypeIdDrp = atob(params['type']);
          
          this.getAllTagsList();
          this.getStateDropdownList(231);
          this.getContactUserDetails();
          this.GetFormReportFolderMappingsFor3C();
          return;
        }
      }
    });

    let group = {};
    this.myFormGroup = new FormGroup(group);
    this.moduleName = sessionStorage.getItem('moduleName');
    this.TypeIdDrp = Number(sessionStorage.getItem('TypeID'));
    this.transactionID = Number(sessionStorage.getItem('transactionID'));
    //this.TypeIdDrp = Number(sessionStorage.getItem('TypeID'));
    // sessionStorage.setItem('transactionID', sessionStorage.getItem('transactionID'));
    // sessionStorage.setItem('TypeID', sessionStorage.getItem('TypeID'));
    sessionStorage.setItem('moduleName', sessionStorage.getItem('moduleName'));
    this.getAllTagsList();
    this.getStateDropdownList(231);
    this.getContactUserDetails();
    this.GetFormReportFolderMappingsFor3C();

    this.CCCList = JSON.parse(sessionStorage.getItem("contactList"));
    if (this.CCCList.length > 0) {
      var transactionID = sessionStorage.getItem('transactionID');
      var Index = this.CCCList.findIndex(el => el.contactID === Number(transactionID));
      if (this.CCCList.length == 1) {
        this.PreviousButton = true;
        this.NextButton = true;
        return;
      }
      if (Index == 0) {
        this.PreviousButton = true;
        this.NextButton = false;
      }
      if (Index == this.CCCList.length - 1) {
        this.PreviousButton = false;
        this.NextButton = true;
      }
      if (Index != 0 && Index != this.CCCList.length - 1) {
        this.PreviousButton = false;
        this.NextButton = false;
      }
    }

    //this.getContactUserDetailsforSubFolderId();   
  }

  getTransactionID() {
    return sessionStorage.getItem('transactionID');
  }

  getAddressField(addressFieldsArray: any, type: number) {
    let field = addressFieldsArray.find(m => m.childFieldType == type);
    return field.fieldValue
  }

  // Used to make Collapsible Panel for group fields
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();
    this.allTags;
    var check = [];
    check = this.allTags.filter(tag => tag.toLowerCase().indexOf(value.trim()) === 0);
    if (check.length > 0) {
      this.fruitCtrl.setValue(null);
      return;
    }

    // Add our tag
    if ((value || '').trim()) {
      var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
      const index = arrToUp.indexOf(value.trim());

      if (index >= 0) {
        //this.fruits.splice(index, 1);
      }
      else {
        this.tags.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.tags.indexOf(fruit);
    if (index >= 0) {
      this.tags.splice(index, 1);
    }
    this.myFormGroup.markAsDirty();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.tags = this.tags.map(function (el) {
      return el.trim();
    });
    const index = this.tags.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.fruitInput.nativeElement.value = '';
      //this.fruits.splice(index, 1);
    }
    else {
      this.tags.push(event.option.viewValue);
      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }


  // getContactUserDetailsforSubFolderId() {
  //   this.coreUserList = [];
  //   var ReqModel={
  //     DatabaseID:Number(this.databaseId),
  //     OrganizationID:Number(this.organizationId),
  //     contactID:Number(sessionStorage.getItem('transactionID')),
  //     FolderId:this.folderID,
  //     userID: this.currentUser.UID
  //   }  
  //   this.coreService.getContactUserDetails(ReqModel).subscribe((response) => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       if (this.responseHolder.status == this.statusConst.statusSuccess) {                   
  //         var TypeData =  response.data.fields.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');
  //         if (TypeData.length > 0 && TypeData !=undefined) {            
  //           if(TypeData[0].fieldValue != ""){
  //             let id: string = TypeData[0].fieldValue.toString();
  //             this.TypeIdDrp = parseInt(id);             
  //           }
  //           else {              
  //             this.TypeIdDrp=0;
  //           }           
  //         }
  //         else{
  //           this.TypeIdDrp=0;
  //         }         
  //         this.getContactUserDetails();
  //       }
  //     }       
  //   });
  // }



  getAllTagsList() {
    this.getTagListModel.databaseID = Number(this.databaseId);
    this.getTagListModel.organizationID = Number(this.organizationId);
    this.getTagListModel.tagName = '';
    this.getTagListModel.PageSize = 0;
    this.settingsService.getAllTagsList(this.getTagListModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.allTags = this.getTagListResponseHolder.data.tagNames;
        }
        else {
        }
      }
    });
  }

  isChecked(fieldName, chk) {
    var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
    if (_newcheckBoxlist[0].selectedCHK != '') {
      return _newcheckBoxlist[0].selectedCHK.toString().includes(chk);
    } else {
      return false;
    }
  }

   OnChange($event: any, chk: any, fieldId: any) {
    this.myFormGroup.get(chk).markAsDirty();
    if (!this.chkStatusArry) {
      this.chkStatusArry = [];
    }
    if ($event.checked) {     
      if(this.chkStatusArry.length>0){
       var checkRecord=[];
       checkRecord = this.chkStatusArry.filter(x=>x.fieldId==fieldId);
       if(checkRecord.length>0){
       this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = chk;
       }
      }else{
       this.chkStatusArry.push({
        ckh: chk,
        fieldId: fieldId,
       });
      }    
    } else {
      if(this.chkStatusArry.length>0){
        this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = '';
      } 
      // if (this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
      //   this.chkStatusArry = this.chkStatusArry.filter((item) => item.ckh != chk);
      // }
    }
  }

  // OnChange($event: any, chk: any, fieldId: any) {
  //   this.myFormGroup.get(chk).markAsDirty();
  //   if (!this.chkStatusArry) {
  //     this.chkStatusArry = [];
  //   }
  //   if ($event.checked) {
  //     this.chkStatusArry.push({
  //       ckh: chk,
  //       fieldId: fieldId,
  //     });
  //   } else {
  //     if (this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
  //       this.chkStatusArry = this.chkStatusArry.filter((item) => item.ckh != chk);
  //     }
  //   }
  // }

  getddlSelectedVal(fieldName) {
    if (this.dropdownlist) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      if (_newdropdownlist[0] && _newdropdownlist[0].selectedVal != '') {
        return _newdropdownlist[0].selectedVal;
      } else {
        return '';
      }
    }
  }

  getMultiddlSelectedVal(fieldName) {
    if (this.multipleDropdownList) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      if (_newMuldropdownlist[0] && _newMuldropdownlist[0].selectedVal != '') {
        if (fieldName != "Tags") {
          return _newMuldropdownlist[0].selectedVal.split(',');
        } else {
          return _newMuldropdownlist[0].selectedVal;
        }
      } else {
        return '';
      }
    }
  }


  getCheckBoxlist(fieldName) {
    if (this.checkBoxList) {
      var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
      if (_newcheckBoxlist[0]) {
        _newcheckBoxlist[0].value.forEach(v => {
          this.myFormGroup.addControl(v, this.formBuilder.control(''));
        });
        return _newcheckBoxlist[0].value;
      }
    }
  }

  getdropdownlist(fieldName) {
    if (this.dropdownlist) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      if (_newdropdownlist.length > 0)
        return _newdropdownlist[0].value;
      else
        "";
    }
  }

  getMuldropdownlist(fieldName) {
    if (this.multipleDropdownList) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      if (_newMuldropdownlist.length > 0)
        return _newMuldropdownlist[0].value;
      else
        "";
    }
  }


  fillCheckBoxList() {
    if (this.coreFieldList) {
      this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');
    }
  }

   prepareCheckboxListForUI() {
    if (this.checkBoxList.length > 0 && this.checkBoxList != undefined) {
      var fieldcheckbox = [];
     this.chkStatusArry=[];
      var value;
      if (!this.chkStatusArry) {
        this.chkStatusArry = [];
      }
      for (let i = 0; i < this.checkBoxList.length; i++) {
        var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
        value = checkboxValue.split(',');
        var selectedVal;
        let chk = this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID);

        if (chk.length > 0) {
          selectedVal = chk[0].fieldValue;
          selectedVal= selectedVal.replace(/,/g, '');
        }
        else {
          selectedVal = this.checkBoxList[i].fieldValue;
          selectedVal= selectedVal.replace(/,/g, '');
        }

        if (selectedVal == undefined || selectedVal == null) {
          selectedVal = "";
        }
        
        var FieldsCheckbox = {
          FieldValue: this.checkBoxList[i].fieldName,
          value: value,
          selectedCHK: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue),checked: false,
        };

        fieldcheckbox.push(FieldsCheckbox);

        let selectedCHKArray = selectedVal.split(','); //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue).toString().split(',');
        for (let n = 0; n < selectedCHKArray.length; n++) {
          this.chkStatusArry.push({
            ckh: selectedCHKArray[n],
            fieldId: this.checkBoxList[i].fieldID,
          });
        }
      }
      this.checkBoxList = fieldcheckbox;
    }
  }
  
  // prepareCheckboxListForUI() {
  //   if (this.checkBoxList.length > 0 && this.checkBoxList != undefined) {
  //     var fieldcheckbox = [];
  //     var value;
  //     if (!this.chkStatusArry) {
  //       this.chkStatusArry = [];
  //     }
  //     for (let i = 0; i < this.checkBoxList.length; i++) {
  //       var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
  //       value = checkboxValue.split(',');
  //       var selectedVal;
  //       let chk = this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID);
  //       if (chk.length > 0) {
  //         selectedVal = chk[0].fieldValue;
  //       }
  //       else {
  //         selectedVal = this.checkBoxList[i].fieldValue
  //       }

  //       if (selectedVal == undefined || selectedVal == null) {
  //         selectedVal = "";
  //       }
  //       //  if(chk.length==0){
  //       //   selectedVal="";
  //       //   } 
  //       var FieldsCheckbox = {
  //         FieldValue: this.checkBoxList[i].fieldName,
  //         value: value,
  //         selectedCHK: selectedVal//this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue),checked: false,
  //       };

  //       fieldcheckbox.push(FieldsCheckbox);

  //       let selectedCHKArray = selectedVal.split(','); //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue).toString().split(',');
  //       for (let n = 0; n < selectedCHKArray.length; n++) {
  //         this.chkStatusArry.push({
  //           ckh: selectedCHKArray[n],
  //           fieldId: this.checkBoxList[i].fieldID,
  //         });
  //       }
  //     }
  //     this.checkBoxList = fieldcheckbox;
  //   }
  // }

  fillMultiDropDown() {
    this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
  }

  prepareMultiDropDownForUI() {
    if (this.multipleDropdownList.length > 0) {
      var fieldmulListdrp = [];
      var value;
      for (let i = 0; i < this.multipleDropdownList.length; i++) {
        var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
        value = muldrpValue.split(',');
        var selectedVal;
        let drp = this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID);
        if (drp.length > 0) {
          selectedVal = drp[0].fieldValue;
        }
        else {
          selectedVal = this.multipleDropdownList[i].fieldValue
        }

        if (selectedVal == undefined || selectedVal == null) {
          selectedVal = "";
        }
        //  if(drp.length==0){
        //   selectedVal="";
        //   }  
        var FieldsMulDrp = {
          FieldValue: this.multipleDropdownList[i].fieldName,
          value: value,
          selectedVal: selectedVal// this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID).map((k) => k.fieldValue).toString().split(','),
        };
        fieldmulListdrp.push(FieldsMulDrp);
      }
      this.multipleDropdownList = fieldmulListdrp;
    }
  }

  fillDropDown() {
    this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown');
    this.dropdownlist.forEach(element => {
      if (element.fieldName == 'Type') { element.defaultValue = this.TypeList }
    });
  }

  prepareDropDownForUI() {
    if (this.dropdownlist.length > 0) {
      var fieldListdrp = [];
      var value;
      for (let i = 0; i < this.dropdownlist.length; i++) {
        if (this.dropdownlist[i].defaultValue.length > 0) {
          var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
          value = drpValue.split(',');
          var selectedVal;
          let drp = this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID);
          if (drp.length > 0) {
            selectedVal = drp[0].fieldValue;
          }
          else {
            selectedVal = this.dropdownlist[i].fieldValue
          }

          if (selectedVal == undefined || selectedVal == null) {
            selectedVal = "";
          }

          if (this.dropdownlist[i].fieldName == "Status") {
            selectedVal = this.statusType;
          }

          var FieldsDrp = {
            FieldValue: this.dropdownlist[i].fieldName,
            value: value,
            selectedVal: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID).map((k) => k.fieldValue),
          };
          fieldListdrp.push(FieldsDrp);
        }
      }
      this.dropdownlist = fieldListdrp;
    }
  }


  getCurrentIndex(fieldName: any) {
    for (let i = 1; i < 10; i++) {
      if (!this.myFormGroup.contains(fieldName + i)) {
        length = i;
        return i;
      }
    }
  }

  appendEle(field: any, type: any, index: any) {
    this.myFormGroup.addControl(field.fieldName, this.formBuilder.control(''));
    this.myFormGroup.addControl(
      field.fieldName + 'option',
      this.formBuilder.control('')
    );
    let plcHolder = field.fieldNames.find((x) => x.fieldNameID == field.fieldNameID);

    let addressRefactor: any = [];
    if (field.address != undefined && field.address.length > 0) {
      addressRefactor.push(field.address.find(x => x.childFieldType == 0));
      addressRefactor.push(field.address.find(x => x.childFieldType == 3));
      addressRefactor.push(field.address.find(x => x.childFieldType == 2));
      addressRefactor.push(field.address.find(x => x.childFieldType == 4));
    }

    //addressRefactor.splice(2,0,field.address.find(x=>x.childFieldType==3));
    let uiField = {
      fieldID: field.fieldID,
      fieldName: field.fieldName,
      fieldNameID: field.fieldNameID,
      fieldNames: field.fieldNames,
      fieldTypeID: field.fieldTypeID,
      fieldTypeName: field.fieldTypeName,
      fieldValue: field.fieldValue,
      transactionID: field.transactionID,
      placeholderVal: plcHolder != null ? plcHolder.fieldName : '',
      address: addressRefactor,
      isPrimary: field.isPrimary
    };

    //1 Email ,2 Address,3 Phone,4 website
    if (type == 2) {
      this.myFormGroup.addControl('City' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + index, this.formBuilder.control(''));

      // address array for computation
      this.addressFormGroup.push('Address' + index);
      this.addressFormGroup.push('City' + index);
      this.addressFormGroup.push('State' + index);
      this.addressFormGroup.push('ZipCode' + index);
      this.addressFormGroup.push('Country' + index);
    }
    if (type == 1) this.dynamicArray.push(uiField);
    if (type == 2) this.dynamicArrayAddress.push(uiField);
    if (type == 3) this.dynamicArrayPhone.push(uiField);
    if (type == 4) this.dynamicArrayWebsite.push(uiField);
  }

  addMore(fieldName: any) {
    if (fieldName.includes('Email')) {
      fieldName = 'Email';
      let length = this.dynamicArray.length;
      length = length + 1;
      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));
      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          ctrl = formControl;
        }
      });

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArray.push(field);
      }
    }
    // Phone
    if (fieldName.includes('Phone')) {
      fieldName = 'Phone';
      let length = this.dynamicArrayPhone.length;
      length = this.getCurrentIndex('Phone');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Phone') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayPhone.push(field);
      }
    }
    //Address
    if (fieldName.includes('Address')) {
      fieldName = 'Address';
      if (this.dynamicArrayAddress == undefined) this.dynamicArrayAddress = [];
      let length = this.dynamicArrayAddress.length;
      length = this.getCurrentIndex('Address');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      this.addressValueField[fieldName + length] = '';
      this.cityValueField['City' + length] = '';
      this.stateValueField['State' + length] = '';
      this.zipValueField['ZipCode' + length] = ''
      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Address') {
          ctrl = formControl;
        }
      });

      this.myFormGroup.addControl('City' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length, this.formBuilder.control(''));

      // address array for computation
      this.addressFormGroup.push('Address' + length);
      this.addressFormGroup.push('City' + length);
      this.addressFormGroup.push('State' + length);
      this.addressFormGroup.push('ZipCode' + length);
      this.addressFormGroup.push('Country' + length);

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var fieldAddress = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
          address: this.emptyArrya
        };
        this.dynamicArrayAddress.push(fieldAddress);
      }
    }
    //Website
    if (fieldName.includes('WebSite')) {
      fieldName = 'WebSite';
      let length = this.dynamicArrayWebsite.length;
      length = this.getCurrentIndex('WebSite');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'WebSite') {
          ctrl = formControl;
        }
      });

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayWebsite.push(field);
      }
    }
  }


  clearPlaceholder(event: any) {
    event.source.placeholder = '';
  }

  getAddressTypeFieldName(childFieldType) {
    if (childFieldType == 3)
      return 'City';
    if (childFieldType == 2)
      return 'State';
    if (childFieldType == 4)
      return 'ZipCode';
    if (childFieldType == 1)
      return 'Country';
  }

  getCoreUserDetailsOnTypeChange(event: any, fieldName: any) {
    this.transactionID;
    this.isTypeChanged = true;
    this.TypeIdDrp = parseInt(event.value);
    this.arryaControlNameIdpare = []
    this.arrayControlNameSubfolderID = [];
    this.getContactUserDetails();
  }

  transactionIDForTask: number = 0;
  typeIdForTask: number = 2;
  NameForTask: string = "";
  EmailForTask: string = "";
  ImageForTask: string = "";
  statusType: string = "";
  entityId:number =0;

  getContactUserDetails() {
    this.transactionIDForTask = Number(this.transactionID);//Number(sessionStorage.getItem('transactionID')); 
    //this.coreUserList = [];
    this.contactVm.DatabaseID = Number(this.databaseId);
    this.contactVm.OrganizationID = Number(this.organizationId);
    this.contactVm.contactID = Number(this.transactionID);//Number(sessionStorage.getItem('transactionID'));
    this.contactVm.FolderId = Number(this.folderID);
    this.contactVm.subFolderID = Number(this.TypeIdDrp);
    //this.contactVm.subFolderID = Number(sessionStorage.getItem('TypeID'));// Number(this.TypeIdDrp); 
    this.contactVm.UserID = this.currentUser.UID;
    this.contactVm.officeID = this.myOfficeID;
    this.contactVm.OfficeIDList = this.OfficeIDList;
    this.loaderService.show();
    this.coreService.getContactUserDetails(this.contactVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.statusType = response.data.status;
          this.coreUserList = response.data.fields;
          this.ImageForTask = response.data.imageUrl;

          this.entityId = response.data.contactID;
          this.TypeListForDropDown = response.data.types;
          this.TypeListForDropDown.splice(0, 0, {
            folderName: "Select",
            isChecked: false,
            subFolderID: 0
          });

          var checkName = [];
          var checkEmail = [];
          checkName = response.data.fields.filter(x => x.fieldName.toLowerCase() == "Name".toLowerCase());
          if (checkName.length > 0) {
            this.NameForTask = checkName[0].fieldValue;
          }
          checkEmail = response.data.fields.filter(x => x.fieldName.toLowerCase() == "Email".toLowerCase());
          if (checkEmail.length > 0) {
            this.EmailForTask = checkEmail[0].fieldValue;
          }

          if (this.responseHolder.data.paychexID == null) {
            this.showPaycheck = false;
          } else {
            this.showPaycheck = true;
          }

          var TypeData = this.coreUserList.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');

          var taglist;

          taglist = this.coreUserList.filter((e) => e.fieldTypeName == 'MultiSelect' && e.fieldName == 'Tags');
          if (taglist.length > 0 && taglist != undefined) {
            this.tags = [];
            if (taglist[0].fieldValue != "") {
              this.tags = taglist[0].fieldValue.split(',');
            }
            else {
              this.tags = [];
            }
          }
          else {
            this.tags = [];
          }

          var NewList;
          NewList = response.data.fields.filter((s) => s.fieldName != 'Type');
          var type;
          type = this.coreUserList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          NewList.splice(1, 0, type[0]);
          this.coreUserList = NewList;
          this.coreUserList = this.coreUserList.filter((s) => s.availableOn != 2);
          this.coreUserList = this.coreUserList.filter((s) => s.rolePermission != 2);
          //Change name for dynamic elements
          //Group them one beneath othe for multi name array
          let multiNameArray = [];
          let ArrayWithGroupedElement = [];
          this.arryaControlNameIdpare=[];
          this.coreUserList.forEach((formControl) => {
            let count = multiNameArray.filter((x) => x.fieldID == formControl.fieldID).length;
            if (count == 0) {
              multiNameArray.push(formControl);
              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });

              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac, i) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType),
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
            else if (count > 0) {
              multiNameArray.push(formControl);
              formControl.fieldName = formControl.fieldName + count;
              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });
              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac, i) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType) + count,
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
          });


          this.coreUserList.forEach((formControl) => {
            let count = ArrayWithGroupedElement.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldNames.length > 0).length;
            let elements = this.coreUserList.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldNames.length > 0);
            if (count == 0 && elements.length > 0) {
              if (elements[0].fieldName.includes('Address')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Address');
                this.dynamicArrayAddressTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Email')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Email');
                this.dynamicArrayTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Phone')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Phone');
                this.dynamicArrayPhoneTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Website')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Website');
                this.dynamicArrayWebsiteTemp = this.dynamicArrayEdit;
              }

              ArrayWithGroupedElement.push(elements[0]);

            }
            if (count == 0 && elements.length == 0)
              ArrayWithGroupedElement.push(formControl);
          });

          this.coreUserList = ArrayWithGroupedElement;
          const Fields = {};
          this.coreUserList.forEach((formControl) => {
            if (formControl.fieldName == 'Name') {
              this.transactionUserName = formControl.fieldValue;
            }
            if (formControl.fieldName == 'Type') {
              let type = this.TypeListForDropDown.find(x => x.subFolderID == formControl.fieldValue);
              this.transactionUserRole = (type != null || type != undefined) ? type.folderName : ""
            }
            Fields[formControl.fieldName] = new FormControl('');
            if (formControl.fieldNames.length > 0) {
              Fields[formControl.fieldName + 'option'] = new FormControl('');
              let plcHolder = formControl.fieldNames.find(
                (x) => x.fieldNameID == formControl.fieldNameID);
              formControl.placeholderVal = plcHolder != null ? plcHolder.fieldName : formControl.fieldNames[0];
            }
          });

          this.ImagePathURL = (response.data.imageUrl == null || response.data.imageUrl == undefined || response.data.imageUrl == '') ? '' : response.data.imageUrl;

          ///
          Fields['City'] = new FormControl();
          Fields['State'] = new FormControl();
          Fields['ZipCode'] = new FormControl();
          Fields['Country'] = new FormControl();
          // address computaion array for computation
          this.addressFormGroup.push('Address');
          this.addressFormGroup.push('City');
          this.addressFormGroup.push('State');
          this.addressFormGroup.push('ZipCode');
          this.addressFormGroup.push('Country');

          ///fruitCtrl
          Fields['fruitCtrl'] = this.fruitCtrl;
          this.myFormGroup = new FormGroup(Fields);

          //#region geting core filds
          var reqModel = {
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
            folderID: this.folderID,//18;
            subFolderID: Number(this.TypeIdDrp),
            fieldID: 0,
            requestFrom: 0,
            officeID: this.myOfficeID,
            OfficeIDList: this.OfficeIDList
          }
          this.coreService.getContactFeildList(reqModel).subscribe((response) => {
            var tempArryacoreFieldList = response.data.activeFields.filter((m) => m.fieldID == 0);
            response.data.activeFields = response.data.activeFields.filter((m) => m.fieldID > 0);
            this.coreFieldList = response.data.activeFields;
            // Modified array containing group starts
            tempArryacoreFieldList.forEach(element => {
              if (element.data.length > 1) {
                var indexArray = [];
                element.data.forEach(elementin => {
                  if (elementin.fieldID > 0) {
                    let grpele = this.coreUserList.find(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    elementin.fieldValue = grpele != undefined ? grpele.fieldValue : "";
                    elementin.id = grpele != undefined ? grpele.id : 0;
                    elementin.isRequired = grpele != undefined ? grpele.isRequired : false;
                    if (elementin.fieldNames.length > 0) {
                      elementin.fieldNameID = grpele.fieldNameID;
                      elementin.placeholderVal = grpele.placeholderVal;
                    }
                    this.coreFieldList.push(elementin);
                    if (!this.myFormGroup.contains(elementin.fieldName)) {
                      this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
                    }
                    var index = this.coreUserList.findIndex(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    indexArray.push(index);
                  }
                });

                this.coreUserList = this.coreUserList.filter(function (value, index) {
                  return indexArray.indexOf(index) == -1;
                });
                this.coreUserList.splice(indexArray[0], 0, element);

              }
            });
            ArrayWithGroupedElement.forEach(element => {
              if (element.fieldName == "Address") {
                if (element.address.length > 0) {
                  if (element.address.find(m => m.childFieldType == 3) != undefined)
                    this.cityValue = element.address.find(m => m.childFieldType == 3).fieldValue;
                  else
                    this.cityValue = "";
                  if (element.address.find(m => m.childFieldType == 2) != undefined)
                    this.stateValue = element.address.find(m => m.childFieldType == 2).fieldValue;
                  else
                    this.stateValue = "";
                  if (element.address.find(m => m.childFieldType == 4) != undefined)
                    this.zipValue = element.address.find(m => m.childFieldType == 4).fieldValue;
                  else
                    this.zipValue = "";
                }
              }
            });

            this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
            this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
            this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');

            var data = [];

            data = this.coreUserList.filter((s) => s.fieldID == 0);

            if (data.length > 0) {
              for (var i = 0, len = data.length; i < len; ++i) {
                var DrpData = [];
                DrpData = data[i].data.filter((s) => s.fieldTypeName == 'Dropdown');
                if (DrpData.length > 0) {
                  for (var v = 0, char = DrpData.length; v < char; ++v) {
                    this.dropdownlist.push(DrpData[v]);
                  }
                }

                var MultiData = [];
                MultiData = data[i].data.filter((s) => s.fieldTypeName == 'MultiSelect');
                if (MultiData.length > 0) {
                  for (var v = 0, char = MultiData.length; v < char; ++v) {
                    this.multipleDropdownList.push(MultiData[v]);
                  }
                }

                var CheckboxData = [];
                CheckboxData = data[i].data.filter((s) => s.fieldTypeName == 'Checkbox');
                if (CheckboxData.length > 0) {
                  for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                    this.checkBoxList.push(CheckboxData[v]);
                  }
                }
              }
            }

            if (this.dropdownlist.length > 0) {
              var fieldListdrp = [];
              var value;
              for (let i = 0; i < this.dropdownlist.length; i++) {

                var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
                value = drpValue.split(',');
                var FieldsDrp = {
                  FieldValue: this.dropdownlist[i].fieldName,
                  value: value,
                };
                fieldListdrp.push(FieldsDrp);
              }
              this.dropdownlist = fieldListdrp;
            }

            if (this.multipleDropdownList.length > 0) {
              var fieldmulListdrp = [];
              var value;
              for (let i = 0; i < this.multipleDropdownList.length; i++) {
                var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                value = muldrpValue.split(',');
                var FieldsMulDrp = {
                  FieldValue: this.multipleDropdownList[i].fieldName,
                  value: value,
                };
                fieldmulListdrp.push(FieldsMulDrp);
              }
              this.multipleDropdownList = fieldmulListdrp;
            }

            if (this.checkBoxList.length > 0) {
              var fieldcheckbox = [];
              var value;
              for (let i = 0; i < this.checkBoxList.length; i++) {
                var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                value = checkboxValue.split(',');
                var FieldsCheckbox = {
                  FieldValue: this.checkBoxList[i].fieldName,
                  value: value,
                };
                fieldcheckbox.push(FieldsCheckbox);
              }
              this.checkBoxList = fieldcheckbox;
            }

            // Modified array containing group ends 
            this.fillCheckBoxList();
            this.prepareCheckboxListForUI();

            this.fillDropDown();
            this.prepareDropDownForUI();

            this.fillMultiDropDown();
            this.prepareMultiDropDownForUI();
          });

          this.dynamicArray = [];
          this.dynamicArrayAddress = [];
          this.dynamicArrayPhone = [];
          this.dynamicArrayWebsite = [];
          this.dynamicArrayTemp.forEach((e, i) => {
            this.appendEle(e, 1, i + 1);
          });
          this.dynamicArrayAddressTemp.forEach((e, i) => {
            this.appendEle(e, 2, i + 1);
          });
          this.dynamicArrayPhoneTemp.forEach((e, i) => {
            this.appendEle(e, 3, i + 1);
          });
          if (this.dynamicArrayWebsiteTemp != undefined)
            this.dynamicArrayWebsiteTemp.forEach((e, i) => {
              this.appendEle(e, 4, i + 1);
            });
          this.loaderService.hide();
          if (this.isTypeChanged) {
            this.myFormGroup.get('Type').markAsDirty();
            this.isTypeChanged = false;
          }
        } else {
          this.coreUserList = [];
        }
      }
    });
  }


  getStateDropdownList(countryId: any) {
    if (countryId != undefined) {
      this.coreService.getStateList(countryId).subscribe(response => {
        if (response != undefined) {
          if (response.status == this.statusConst.statusSuccess) {
            this.stateList = [];
            if (countryId == 231 || countryId == 38) {
              response.data = response.data.filter((x) => x.abbreviation != null);
              response.data.forEach(e => {
                this.stateList.push(e.abbreviation);
              });
            } else {
              response.data.forEach(e => {
                this.stateList.push(e.stateName);
              });
            }
          }
        }
      });
    }
  }

  searchZip(zip: any) {
    this.ZipModel.databaseID = Number(this.databaseId);
    this.ZipModel.ZipCodeValue = zip;
    this.ZipModel.userID = this.currentUser.UID;;
    this.coreService.searchTransZip(this.ZipModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          this.zipOption = [];
          response.data.forEach(element => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }

  searchCity(name: any) {
    this.CityModel.databaseID = Number(this.databaseId);
    this.CityModel.Name = name;
    this.CityModel.userID = this.currentUser.UID;;
    this.coreService.searchTransCities(this.CityModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          this.cityOption = [];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }


  getSubFolderFields(event, fieldName) {
    if (event != undefined && fieldName == "Type") {
      this.TypeIdDrp = event.value;
    }
  }

  getShortName(fullName) {
    if (fullName != undefined) {
      if (fullName.includes(' ')) {
        return fullName
          .split(' ')
          .map((n) => n[0])
          .join('');
      }
      return fullName.substring(0, 1);
    }
    return '';
  }

  onSelectFile(fileInput: any) {
    this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var test = filename.split('.');
    this.FileName = test[0];
    this.FileExtention = '.' + test[1];
    this.myFormGroup.markAsDirty();
  }

  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.fileModelVM.UserID = this.currentUser.UID;
    this.fileModelVM.DatabaseID = Number(this.databaseId);
    this.fileModelVM.OrganizationID = Number(this.organizationId);
    this.fileModelVM.Base64String = this.imageSrc;
    this.fileModelVM.FileName = this.FileName;
    this.fileModelVM.FileExtention = this.FileExtention;
    this.coreService.getImageUlpoadURL(this.fileModelVM).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ImagePathURL = response.data;
        }
      }
    });
  }

  isCheckedPrimary(fieldName, chk) {
    if (fieldName.isPrimary == true) {
      return true;
    } else {
      return false;
    }
  }


  isCheckedParent(fieldName, chk) {
    if (fieldName.isPrimary == true) {
      return true;
    } else {
      return false;
    }
  }


  check: boolean = false;
  isPrimary: boolean = false;
  EmaildArray: any = [];

  MakePrimaryChild($event: any, field: any) {
    this.coreUserList.field;
    this.coreUserList.forEach(e => {
      if (e.fieldName == "Email") {
        e.isPrimary = false
      }
    });
    this.coreUserList.map(e => {
      if (e.fieldID == 0 && e.data.length > 0) {
        e.data.map(e1 => {
          if (e1.fieldName == "Email") {
            e1.isPrimary = false
          }
          return e1;
        });
      }

    });

    this.cdr.detectChanges();
    this.myFormGroup.get(field.fieldName).markAsDirty();
    this.coreUserList;
    this.check = false;
    this.dynamicArray.forEach(e => {
      if (e.fieldName == field.fieldName) {
        e.isPrimary = true;
      } else {
        e.isPrimary = false;
      }
    });

    var check = this.EmaildArray.filter((s) => s.fieldName == field.fieldName);
    if (check.length == 0) {
      var ReqModel = {
        fieldID: field.fieldID,
        fieldName: field.fieldName,
        fieldValue: field.fieldValue,
        isPrimary: true
      }
      this.EmaildArray.push(ReqModel);
    } else {
      this.EmaildArray.find((item) => item.fieldName == field.fieldName).isPrimary = true;
      this.EmaildArray.find((item) => item.fieldName == field.fieldName).fieldValue = field.fieldValue;
      this.EmaildArray.forEach(e => {
        if (e.fieldName == field.fieldName) {
          e.isPrimary = true;
        } else {
          e.isPrimary = false;
        }
      });
    }
  }


  MakePrimaryParent($event: any, field: any) {
    this.coreUserList.forEach(e => {
      if (e.fieldName == "Email") {
        e.isPrimary = true
      }
    });
    this.coreUserList.map(e => {
      if (e.fieldID == 0 && e.data.length > 0) {
        e.data.map(e1 => {
          if (e1.fieldName == "Email") {
            e1.isPrimary = true
          }
          return e1;
        });
      }
    });

    this.cdr.detectChanges();
    this.myFormGroup.get(field.fieldName).markAsDirty();

    this.dynamicArray.forEach(e => {
      e.isPrimary = false;
    });

    var check = this.EmaildArray.filter((s) => s.fieldName == field.fieldName);
    if (check.length == 0) {
      var ReqModel = {
        fieldID: field.fieldID,
        fieldName: field.fieldName,
        fieldValue: field.fieldValue,
        isPrimary: true
      }
      this.EmaildArray.push(ReqModel);
    } else {
      this.EmaildArray.find((item) => item.fieldName == field.fieldName).isPrimary = true;
      this.EmaildArray.find((item) => item.fieldName == field.fieldName).fieldValue = field.fieldValue;

      this.EmaildArray.forEach(e => {
        if (e.fieldName == field.fieldName) {
          e.isPrimary = $event.checked;
        } else {
          e.isPrimary = false;
        }
      });
    }
  }

  SaveCoreUserDetails(formValues: any) {
    this.saveContactDetails(formValues);
  }

  saveContactDetails(formValues) {
    if (formValues !== undefined) {
      this.addContactVm.DatabaseID = Number(this.databaseId);
      this.addContactVm.UserID = this.currentUser.UID;
      this.addContactVm.ContactID = Number(sessionStorage.getItem('transactionID'));//Number(this.transactionID);
      this.addContactVm.OrganizationID = Number(this.organizationId);
      var fieldList = [];
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldList.find((m) => m.fieldName == key)) {
          this.coreFieldList.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldList.find((m) => key.includes(m.fieldName));
          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option') &&
            control
          ) {
            if (control.fieldNames.length > 0) {
              tempList.push({
                fieldID: Number(control.fieldID),
                fieldName: key,
                fieldValue: formValues[key],
                fieldNameID:
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? control.fieldNames[0].fieldNameID
                    : Number(formValues[key + 'option']),
              });
            }
          }
        }

        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0) {
              var selectedValueChk = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');

              var str = selectedValueChk;
              selectedValues = str.replace(/^,|,$/g, '');

              selectedValues = Array.from(new Set(selectedValues.split(','))).toString();

            } else {
              selectedValues = '';
            }
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues = this.tags.join(', ');

              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.TypeIdDrp != undefined) {
                selectedValues = this.TypeIdDrp.toString();
              } else {
                selectedValues = '0';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];//.join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Image') {
            selectedValues = this.ImagePathURL;
          }
          let frmctrl = this.arryaControlNameIdpare.find(e => e.name == key);
          let ctrlsfi = this.arrayControlNameSubfolderID.find(e => e.name == key);
          var primaryEmail: boolean = false;
          var primary = this.EmaildArray.filter(x => x.fieldName == key);
          if (primary.length > 0) {
            primaryEmail = primary[0].isPrimary;
          } else {
            primaryEmail = false;
          }
          fieldList.push({
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
            SubFolderID: ctrlsfi != undefined ? ctrlsfi.subfolderID : 0,
            ChildFields: [],
            id: frmctrl != undefined ? frmctrl.id : 0,
            isPrimary: primaryEmail
          });
        }
      }

      /*************/
      //   Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      let indexDefault = fieldList.findIndex(n => n.FieldName == 'Address');
      let AddressDefault = fieldList.find(n => n.FieldName == 'Address');

      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'City') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'City').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["City"],
        "childFieldType": 3
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'State') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'State').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["State"],
        "childFieldType": 2
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'ZipCode') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'ZipCode').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["ZipCode"],
        "childFieldType": 4
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'Country') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'Country').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["Country"],
        "childFieldType": 1
      })
      fieldList = fieldList.filter(function (value, index) {
        return index != indexDefault;
      });
      fieldList.splice(indexDefault, 0, AddressDefault);
      /************/
      /***********/

      this.dynamicArrayAddress.forEach((element, i) => {
        i = i + 1;
        let cityctrl = this.arryaControlNameIdpare.find(e => e.name == 'City' + i);
        let statectrl = this.arryaControlNameIdpare.find(e => e.name == 'State' + i);
        let zipcodectrl = this.arryaControlNameIdpare.find(e => e.name == 'ZipCode' + i);
        let countryctrl = this.arryaControlNameIdpare.find(e => e.name == 'Country' + i);
        let indexDynamic = fieldList.findIndex(n => n.FieldName == 'Address' + i);
        let AddressDynamic = fieldList.find(n => n.FieldName == 'Address' + i);
        AddressDynamic.ChildFields.push({
          "id": cityctrl != undefined ? cityctrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["City" + i],
          "childFieldType": 3
        })
        AddressDynamic.ChildFields.push({
          "id": statectrl != undefined ? statectrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["State" + i],
          "childFieldType": 2
        })
        AddressDynamic.ChildFields.push({
          "id": zipcodectrl != undefined ? zipcodectrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["ZipCode" + i],
          "childFieldType": 4
        })
        AddressDynamic.ChildFields.push({
          "id": countryctrl != undefined ? countryctrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["Country" + i],
          "childFieldType": 1
        })
        fieldList = fieldList.filter(function (value, index) {
          return index != indexDynamic;
        });
        fieldList.splice(indexDynamic, 0, AddressDynamic);

      });
      
      fieldList = fieldList.filter(x => x.FieldName != "Status");
      //********** */
     // fieldList=fieldList.filter(x=>x.id!=0 && x.FieldValue!="");
      this.addContactVm.ImageUrl = this.ImagePathURL;
      this.addContactVm.Fields = fieldList;
      this.addContactVm.TypeID = Number(this.TypeIdDrp) > 0 ? Number(this.TypeIdDrp) : 0;
      this.addContactVm.Tags = this.tagvalues;
      this.addContactVm.officeID = this.myOfficeID;
      this.addContactVm.OfficeIDList = this.OfficeIDList;
      this.addContactVm.Status = formValues.Status;
      this.loaderService.show();
      this.coreService.saveContactUserDetails(this.addContactVm).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());
            this.loaderService.hide();
            this.EmaildArray = [];
            this.myFormGroup.markAsPristine();
            this.toastr.success('Record update successfully.', '', {
              timeOut: 3000,
            });
            this.getContactUserDetails();
            // this.getContactUserDetailsforSubFolderId(); 
          } else {
            this.loaderService.hide();
            this.EmaildArray = [];
            this.myFormGroup.markAsPristine();
          }
        } else {
          this.loaderService.hide();
          this.EmaildArray = [];
          this.myFormGroup.markAsPristine();
        }
      });
    }

  }

  revertForm() {
    if (this.myFormGroup.dirty) {
      this.getContactUserDetails();
      // this.getContactUserDetailsforSubFolderId(); 
      this.myFormGroup.markAsPristine();
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  PreviousRecord() {
    this.matTabIndex = 0;
    if (this.CCCList.length > 0) {
      var transactionID = sessionStorage.getItem('transactionID');
      var Index = this.CCCList.findIndex(el => el.contactID === Number(transactionID));
      Index = Index - 1;
      var check;
      check = this.CCCList[Index];
      if (check != null && check != undefined) {
        if (Index == 0) {
          this.PreviousButton = true;
          this.NextButton = false;
        }
        if (Index == this.CCCList.length - 1) {
          this.PreviousButton = false;
          this.NextButton = true;
        }
        if (Index != 0 && Index != this.CCCList.length - 1) {
          this.PreviousButton = false;
          this.NextButton = false;
        }

        var CheckFields = [];
        CheckFields = check.fields.filter(x => x.fieldName == "Type");
        if (CheckFields.length > 0) {
          this.TypeIdDrp = CheckFields[0].subFolderID;
          sessionStorage.setItem('transactionID', check.contactID);
          sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());
          this.transactionID = check.contactID;
          this.getContactUserDetails();
          this._dataSharingService.sendNextPreviousDocumentFromContact(true);
          this._dataSharingService.sendNextPreviousForRightPanelFromContact(true);
          this._dataSharingService.sendNextPreviousForTouchesFromContact(true);
        } else {
          this.TypeIdDrp = 0;
          sessionStorage.setItem('transactionID', check.contactID);
          sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());
          this.transactionID = check.contactID;
          this.getContactUserDetails();
          this._dataSharingService.sendNextPreviousDocumentFromContact(true);
          this._dataSharingService.sendNextPreviousForRightPanelFromContact(true);
          this._dataSharingService.sendNextPreviousForTouchesFromContact(true);
        }
      }
    }
  }

  NextRecord() {
    this.matTabIndex = 0;
    if (this.CCCList.length > 0) {
      var transactionID = sessionStorage.getItem('transactionID');
      var Index = this.CCCList.findIndex(el => el.contactID === Number(transactionID));
      Index = Index + 1;
      var check;
      check = this.CCCList[Index];
      if (check != null && check != undefined) {
        if (Index == 0) {
          this.PreviousButton = true;
          this.NextButton = false;
        }
        if (Index == this.CCCList.length - 1) {
          this.PreviousButton = false;
          this.NextButton = true;
        }
        if (Index != 0 && Index != this.CCCList.length - 1) {
          this.PreviousButton = false;
          this.NextButton = false;
        }

        var CheckFields = [];
        CheckFields = check.fields.filter(x => x.fieldName == "Type");
        if (CheckFields.length > 0) {
          this.TypeIdDrp = CheckFields[0].subFolderID;
          sessionStorage.setItem('transactionID', check.contactID);
          sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());
          this.transactionID = check.contactID;
          this.getContactUserDetails();
          this._dataSharingService.sendNextPreviousDocumentFromContact(true);
          this._dataSharingService.sendNextPreviousForRightPanelFromContact(true);
          this._dataSharingService.sendNextPreviousForTouchesFromContact(true);
          this._dataSharingService.sendNextPreviousDocumentFromContact(true);
          this._dataSharingService.sendNextPreviousForTaskFrom3C(2);
        } else {
          this.TypeIdDrp = 0;
          sessionStorage.setItem('transactionID', check.contactID);
          sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());
          this.transactionID = check.contactID;
          this.getContactUserDetails();
          this._dataSharingService.sendNextPreviousDocumentFromContact(true);
          this._dataSharingService.sendNextPreviousForRightPanelFromContact(true);
          this._dataSharingService.sendNextPreviousForTouchesFromContact(true);
          this._dataSharingService.sendNextPreviousDocumentFromContact(true);
          this._dataSharingService.sendNextPreviousForTaskFrom3C(2);
        }
      }
    }
  }


  onChangeEmail(searchValue: string, element, field, status) {
    //   var checkelement=[];
    //   if(status!=false){
    //     if(field.fieldValue.toLowerCase() == searchValue.toLowerCase()){
    //       this.myFormGroup.markAsPristine();
    //     }else{

    //     }
    //   }

    //   checkelement = this.dynamicArray.filter((x) => x.fieldValue.toLowerCase() == searchValue.toLowerCase() && x.fieldName!=element.fieldName);
    //   if(checkelement.length>0){
    //     this.myFormGroup.markAsPristine();
    //    } else{
    //  }
  }

  /* Left Pannel User Fields*/
  openUserDetail() {
    this.showUserDetail = !this.showUserDetail;
  }
  /* Left Pannel User Fields*/

  /* CONTACT LIST IN RESPONSIVE */
  openContactList() {
    this.showContactList = !this.showContactList;
  }
  /* CONTACT LIST IN RESPONSIVE */

  /* DOCUMENT DETAL OPEN/CLOSE */
  getDocumentDetail(message: boolean) {
    this.openDocumentDetail = message;
  }

  getClose(closeDetail: boolean) {
    this.openDocumentDetail = closeDetail;
  }
  /* DOCUMENT DETAL OPEN/CLOSE */

  /* Share Docuemnts OPEN/CLOSE */
  getShareFile(message: boolean) {
    this.showShareFile = message;
  }

  getCloseShareFile(closeShare: boolean) {
    this.showShareFile = closeShare;
  }
  /* Share Docuemnts OPEN/CLOSE */

  /* Docuemnt Viewer OPEN/CLOSE */
  getdocumentViewer(message: boolean) {
    this.documentViewer = message;
  }

  getCloseDocumentViewer(closeShare: boolean) {
    this.documentViewer = closeShare;
  }


  gethtmlData(message: boolean) {
    this.htmlData = message;
  }

  getCloseHtmlData(closeShare: boolean) {
    this.htmlData = closeShare;
  }

  /* Docuemnt Viewer OPEN/CLOSE */

  /* CREATE TOCUHES  OPEN/CLOSE */
  getshowCreate(messages: boolean) {
    this.showCreateTouches = messages;
  }
  closeTouches(messages: boolean) {
    this.showCreateTouches = messages;
  }
  /* CREATE TOCUHES  OPEN/CLOSE */

  /* Contact Detail OPEN/CLOSE */
  getContactDetail(messages: boolean) {
    this.showContactdetail = messages;
  }
  getCloseDetail(message: boolean) {
    this.showContactdetail = message;
  }
  /* Contact Detail OPEN/CLOSE */

  /* Create Task OPEN/CLOSE */
  getcreateTask(messages: boolean) {
    this.showCreateTask = messages;
  }
  closeCreateTask(messages: boolean) {
    this.showCreateTask = messages;
  }
  /* Create Task OPEN/CLOSE */

  /* SHow LINK PI  OPEN/CLOSE */
  getLinkPI(messages: boolean) {
    this.showLinkPI = messages;
  }

  closeLinkPI(messages: boolean) {
    this.showLinkPI = messages;
  }
  /* SHow LINK PI  OPEN/CLOSE */

  /* Task Detail  OPEN/CLOSE */
  getTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
  }
  closeTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
  }

  showTouches: boolean = false;
  showTask: boolean = false;
  showTaskListsLeft: boolean = false;
  showEmail: boolean = false;
  showFormReports: boolean = false;
  showCustomInfo: boolean = false;

  getAllFoldersField(event) {
    this.matTabIndex = event.index;
    this.showTask = false;
    this._dataSharingService.sendHideTaskListCore();
    if (event.tab.textLabel == "Activity" || event.index == 1) {
      this.showTouches = true;
    }

    if (event.tab.textLabel == "Custom Info" || event.index == 2) {
      this.showCustomInfo = true;
    }

    if (event.tab.textLabel == "Task" || event.index == 3) {
      this.showTask = true;
      this.settingsService.openTaskTrigger.next(null)
    }

    if (event.tab.textLabel == "Email" || event.index == 4) {
      this.showEmail = true;
    }
    if (event.tab.textLabel == "Form Reports" || event.index == 5) {
      this.showFormReports = true;
      this.settingService.openFormReportTrigger.next('Contact');
    }
    // if(sessionStorage.getItem('moduleName') == "Contact"){
    //   if (event != undefined) {
    //     if (event.tab.textLabel == this.folderText) {
    //       this.getFieldModel.databaseID = Number(this.databaseId);
    //       this.getFieldModel.userID = this.currentUser.UID;
    //       this.getFieldModel.folderID = this.folderID;
    //       this.settingService.getFolderFields(this.getFieldModel).subscribe((response) => {
    //           if (response) {
    //             this.getFieldsListResponseHolder = response;
    //             if(this.getFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
    //               this.fieldsList = this.getFieldsListResponseHolder.data;  
    //               this.fieldsList.forEach((element) => {
    //                 if (element.fieldTypeName == this.constant.TextArea) {
    //                   this.showTextBoxField = true;
    //                   this.showDropdownBoxField = false;
    //                   this.showCheckboxField = false;
    //                   this.inputTypeFieldAttribute.fieldText =
    //                     element.defaultValue;
    //                   this.inputTypeFieldArray.push(this.inputTypeFieldAttribute);
    //                   this.checkBoxFieldArray = [];
    //                   this.dropdownFieldArray = [];
    //                 } else if (
    //                   element.fieldTypeName == this.constant.DropDownField
    //                 ) {
    //                   this.showDropdownBoxField = true;
    //                   this.showTextBoxField = false;
    //                   this.showCheckboxField = false;
    //                   this.dropdownFieldAttribute.fieldText =
    //                     element.defaultValue;
    //                   this.dropdownFieldArray.push(this.dropdownFieldAttribute);
    //                   this.inputTypeFieldArray = [];
    //                   this.checkBoxFieldArray = [];
    //                 } else if (
    //                   element.fieldTypeName == this.constant.CheckboxField
    //                 ) {
    //                   this.showCheckboxField = true;
    //                   this.showDropdownBoxField = false;
    //                   this.showTextBoxField = false;
    //                   this.checkBoxFieldArray.push(this.checkBoxFieldAttribute);
    //                   this.inputTypeFieldArray = [];
    //                   this.dropdownFieldArray = [];
    //                 } else {
    //                 }
    //               });
    //             } else {
    //               this.loaderService.hide();
    //             }
    //           }
    //         });
    //     }
    //   }
    // }


  }


  OpenTaskLists(val: any) {
    this.settingService.openTaskTrigger.next(val)
  }

  getMyTask() {
    this.settingService.openMyTaskTrigger.next("getMyTask");
  }

  clearDate(field) {
    return field.fieldValue="";    
  }

  expandUserInfo = false;
  previousCoreUserList:any=[]=[];

  // expandUserDetail(){
  //   this.expandUserInfo = !this.expandUserInfo
  // }
  
  expandUserDetail(){
    this.expandUserInfo = !this.expandUserInfo;  
    if(this.expandUserInfo==true){
      this.previousCoreUserList = [...this.coreUserList];  
      this.coreUserList;
      this.coreUserList = this.reorderUsers([...this.coreUserList]); 
    }else{
      this.coreUserList = [...this.previousCoreUserList];
    }   
  }

  reorderUsers(users: any[]): any[] {
    return users.sort((a, b) => ((a.data?.length || 0) > 0 ? 1 : (b.data?.length || 0) > 0 ? -1 : 0));
   // return users.sort((a, b) => (a.id === 0 ? 1 : b.id === 0 ? -1 : 0));
  }
  

  FormReportfolderList:any=[]=[];
  cType=2;
  FormFolderReportList:any=[]=[];

   GetFormReportFolderMappingsFor3C() {
    var ReqModel = {
      cType:this.cType,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.settingsService.getFormReportFolderMappingsFor3C(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormReportfolderList = this.responseHolder.data.topForms;
          this.FormFolderReportList = this.responseHolder.data.formReportFolders;    
        }
        else {        
          this.FormReportfolderList=[];
          this.FormFolderReportList=[];
        }
      }
      else {      
        this.FormReportfolderList=[];  
        this.FormFolderReportList=[];     
      }
    });
  }

  openHTML(record:any){
    const dialogRef = this.dialog.open(OpenHTMLFormComponent, {     
      data: {
        htmlData:record,
        transactionID : Number(sessionStorage.getItem('transactionID')) ,
        type:2,  //  Core=1, Contact=2, Company=3
        panelClass: 'previweHTMLForm',
      }
    });
  }

  openAIToolDetail: boolean = false;
  azureblobPath: string="";
  documentsId:number=0;
  documentNames: string="";
  
  getAIDetails(document: any) {
    this.azureblobPath=document.azureblobPath;
    this.documentsId= document.fileManagerItemID;
    this.documentNames = document.name;  
    this.openAIToolDetail = true;
  }

  getCloseAIToolDetail() {
    this.openAIToolDetail = false;
  }
}
